import { callAPI } from "../../network/networkConnection";
import { NetworkConfiguration } from "../../network/networkConfriguation";

const BASE_URL = process.env.REACT_APP_APIUrl;

export const AIModelService = {
  // ===================== AI MODELS =====================
  
  getAllModels: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const url = `${BASE_URL}${NetworkConfiguration.ADMIN_AI_MODELS}${queryString ? `?${queryString}` : ''}`;
    return callAPI(url, "GET", { "Content-Type": "application/json" });
  },

  getModelById: (id) => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_MODELS}/${id}`,
      "GET",
      { "Content-Type": "application/json" }
    );
  },

  createModel: (data) => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_MODELS}`,
      "POST",
      { "Content-Type": "application/json" },
      JSON.stringify(data)
    );
  },

  updateModel: (id, data) => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_MODELS}/${id}`,
      "PUT",
      { "Content-Type": "application/json" },
      JSON.stringify(data)
    );
  },

  deleteModel: (id) => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_MODELS}/${id}`,
      "DELETE",
      { "Content-Type": "application/json" }
    );
  },

  testModel: (id) => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_MODELS}/${id}/test`,
      "POST",
      { "Content-Type": "application/json" }
    );
  },

  getBedrockModels: () => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_MODELS}/bedrock-list`,
      "GET",
      { "Content-Type": "application/json" }
    );
  },

  getBedrockStatus: () => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_MODELS}/bedrock-status`,
      "GET",
      { "Content-Type": "application/json" }
    );
  },

  // ===================== AI USAGE LOGS =====================

  getUsageLogs: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return callAPI(
      `${BASE_URL}admin/ai-usage-logs${queryString ? `?${queryString}` : ''}`,
      "GET",
      { "Content-Type": "application/json" }
    );
  },

  getUsageStats: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return callAPI(
      `${BASE_URL}admin/ai-usage-stats${queryString ? `?${queryString}` : ''}`,
      "GET",
      { "Content-Type": "application/json" }
    );
  },

  cleanupOldLogs: (daysOld = 90) => {
    return callAPI(
      `${BASE_URL}admin/ai-usage-logs/cleanup`,
      "DELETE",
      { "Content-Type": "application/json" },
      JSON.stringify({ daysOld })
    );
  },

  // ===================== AI PROMPTS =====================

  getAllPrompts: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const url = `${BASE_URL}${NetworkConfiguration.ADMIN_AI_PROMPTS}${queryString ? `?${queryString}` : ''}`;
    return callAPI(url, "GET", { "Content-Type": "application/json" });
  },

  getPromptById: (id) => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_PROMPTS}/${id}`,
      "GET",
      { "Content-Type": "application/json" }
    );
  },

  getPromptByPageAction: (page, action) => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_PROMPTS}/by-page-action?page=${encodeURIComponent(page)}&action=${encodeURIComponent(action)}`,
      "GET",
      { "Content-Type": "application/json" }
    );
  },

  createPrompt: (data) => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_PROMPTS}`,
      "POST",
      { "Content-Type": "application/json" },
      JSON.stringify(data)
    );
  },

  updatePrompt: (id, data) => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_PROMPTS}/${id}`,
      "PUT",
      { "Content-Type": "application/json" },
      JSON.stringify(data)
    );
  },

  deletePrompt: (id) => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_PROMPTS}/${id}`,
      "DELETE",
      { "Content-Type": "application/json" }
    );
  },

  duplicatePrompt: (id, data = {}) => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_PROMPTS}/${id}/duplicate`,
      "POST",
      { "Content-Type": "application/json" },
      JSON.stringify(data)
    );
  },

  getAvailablePages: () => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_PROMPTS}/pages`,
      "GET",
      { "Content-Type": "application/json" }
    );
  },

  // ===================== AI STATUS & GENERATION =====================

  getAIStatus: () => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_STATUS}`,
      "GET",
      { "Content-Type": "application/json" }
    );
  },

  getModelsForPage: (page, action) => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_MODELS_FOR_PAGE}?page=${encodeURIComponent(page)}&action=${encodeURIComponent(action)}`,
      "GET",
      { "Content-Type": "application/json" }
    );
  },

  // Generate with dynamic prompt/model selection
  generateWithPrompt: ({ promptSlug, page, action, templateData, maxTokens }) => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_GENERATE}`,
      "POST",
      { "Content-Type": "application/json" },
      JSON.stringify({ promptSlug, page, action, templateData, maxTokens })
    );
  },

  // Generate with specific model
  generateWithModel: (modelId, { prompt, maxTokens, type, systemPrompt }) => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_GENERATE}/${modelId}`,
      "POST",
      { "Content-Type": "application/json" },
      JSON.stringify({ prompt, maxTokens, type, systemPrompt })
    );
  },

  // ===================== AI USAGE LOGS =====================

  getUsageLogs: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const url = `${BASE_URL}${NetworkConfiguration.ADMIN_AI_USAGE_LOGS}${queryString ? `?${queryString}` : ''}`;
    return callAPI(url, "GET", { "Content-Type": "application/json" });
  },

  getUsageStats: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const url = `${BASE_URL}${NetworkConfiguration.ADMIN_AI_USAGE_STATS}${queryString ? `?${queryString}` : ''}`;
    return callAPI(url, "GET", { "Content-Type": "application/json" });
  },

  deleteOldLogs: (daysOld = 90) => {
    return callAPI(
      `${BASE_URL}${NetworkConfiguration.ADMIN_AI_USAGE_LOGS}/cleanup`,
      "DELETE",
      { "Content-Type": "application/json" },
      JSON.stringify({ daysOld })
    );
  },
};

export default AIModelService;
